/* SACHISICY ICY v4: clouds, promo dock, matrix transitions */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    /* clouds */
    if (!document.getElementById('icy-clouds')) {
      var cl = document.createElement('div'); cl.id = 'icy-clouds'; cl.setAttribute('aria-hidden', 'true');
      var small = window.innerWidth < 700;
      var specs = [[620,8,.18,16,140,-20],[420,22,.13,12,105,-70],[760,40,.15,20,170,-110],[360,58,.12,10,95,-35],[540,72,.16,16,150,-90],[300,14,.10,9,80,-55],[680,84,.12,18,190,-150]];
      specs.slice(0, small ? 5 : 7).forEach(function (s) {
        var c = document.createElement('div'); c.className = 'icy-cloud';
        var w = small ? Math.round(s[0] * .6) : s[0];
        c.style.cssText = '--w:' + w + 'px;top:' + s[1] + '%;--o:' + s[2] + ';--b:' + s[3] + 'px;--t:' + s[4] + 's;--d:' + s[5] + 's';
        c.innerHTML = '<i></i><i></i><i></i><i></i><i></i>';
        cl.appendChild(c);
      });
      document.body.insertBefore(cl, document.body.firstChild);
    }

    /* promo dock */
    var KEY = 'icyPromoClosedAt', closed = 0;
    try { closed = +localStorage.getItem(KEY) || 0; } catch (e) {}
    var path = location.pathname;
    if (Date.now() - closed > 24 * 3600 * 1000 && !/\/(cart|checkouts?|account)/.test(path) && !document.getElementById('icy-promo')) {
      var msgs = [
        'Complete the fit: <b>2+ pieces = 10% off</b>',
        '<b>Free US shipping</b> on $75+',
        'Hoodie + sweats = <b>20% off</b> sweats',
        'Discord fam gets <b>15% off</b> ❄'
      ];
      var p = document.createElement('div'); p.id = 'icy-promo'; p.setAttribute('role', 'region'); p.setAttribute('aria-label', 'Current deals');
      p.innerHTML =
        '<div class="icy-promo__orb" aria-hidden="true"><svg viewBox="0 0 62 62">' +
          '<defs><clipPath id="icyGc"><circle cx="31" cy="31" r="20"/></clipPath></defs>' +
          '<circle cx="31" cy="31" r="20" fill="none" stroke="#BFE1FF" stroke-width="1.6"/>' +
          '<g clip-path="url(#icyGc)" stroke="#8EC5FF" stroke-width="1" fill="none">' +
            '<ellipse cx="31" cy="31" rx="20" ry="7"/><ellipse cx="31" cy="31" rx="20" ry="14"/><line x1="11" y1="31" x2="51" y2="31"/>' +
            '<g class="icy-globe-merid" style="transform-origin:31px 31px"><ellipse cx="31" cy="31" rx="10" ry="20"/></g>' +
            '<g class="icy-globe-merid" style="transform-origin:31px 31px;animation-delay:-1.5s"><ellipse cx="31" cy="31" rx="17" ry="20"/></g>' +
            '<line x1="31" y1="11" x2="31" y2="51"/>' +
          '</g>' +
          '<g class="icy-orbit"><ellipse cx="31" cy="31" rx="29" ry="10" fill="none" stroke="rgba(190,225,255,.55)" stroke-width="1" stroke-dasharray="3 4" transform="rotate(-24 31 31)"/>' +
            '<g transform="translate(55 20)"><g class="icy-promo__flake" stroke="#fff" stroke-width="1.6" stroke-linecap="round"><line x1="0" y1="-6" x2="0" y2="6"/><line x1="-5.2" y1="-3" x2="5.2" y2="3"/><line x1="-5.2" y1="3" x2="5.2" y2="-3"/></g></g></g>' +
        '</svg></div>' +
        '<a class="icy-promo__copy" href="/collections/all-over-print-fits" style="color:inherit;text-decoration:none">' +
          '<span class="icy-promo__kicker">❄ Icys World deals</span><span class="icy-promo__msgs">' +
          msgs.map(function (m, i) { return '<span class="icy-promo__msg' + (i === 0 ? ' is-on' : '') + '">' + m + '</span>'; }).join('') +
        '</span></a>' +
        '<button class="icy-promo__x" type="button" aria-label="Close deals banner">✕</button>';
      document.body.appendChild(p);
      document.body.classList.add('icy-has-promo');
      var links = ['/collections/all-over-print-fits', '/collections/all', '/collections/all-over-print-fits', 'https://discord.gg/icysworld'];
      var copy = p.querySelector('.icy-promo__copy');
      var items = p.querySelectorAll('.icy-promo__msg'), k = 0;
      setTimeout(function () { p.classList.add('is-in'); }, 700);
      if (items.length > 1) setInterval(function () {
        items[k].classList.remove('is-on'); k = (k + 1) % items.length; items[k].classList.add('is-on');
        copy.setAttribute('href', links[k]);
        if (links[k].indexOf('http') === 0) { copy.target = '_blank'; copy.rel = 'noopener'; } else { copy.removeAttribute('target'); }
      }, 3800);
      p.querySelector('.icy-promo__x').addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        try { localStorage.setItem(KEY, String(Date.now())); } catch (err) {}
        p.classList.add('is-out'); document.body.classList.remove('icy-has-promo');
        setTimeout(function () { p.remove(); }, 600);
      });
    }

    /* matrix rain inside the page-transition curtain */
    function matrix() {
      var fz = document.getElementById('icy-freeze');
      if (!fz) return setTimeout(matrix, 50);
      if (fz.querySelector('canvas')) return;
      var cv = document.createElement('canvas'); fz.insertBefore(cv, fz.firstChild);
      var ctx = cv.getContext('2d'), W, H, cols, drops, fs, dpr = Math.min(window.devicePixelRatio || 1, 2);
      var glyphs = '0123456789ICYSWORLD❄アイスカキク01'.split('');
      function size() {
        W = window.innerWidth; H = window.innerHeight; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        fs = W < 700 ? 14 : 17; cols = Math.ceil(W / fs); drops = [];
        for (var i = 0; i < cols; i++) drops[i] = Math.random() * (H / fs) * 1.1 - (H / fs) * 0.3;
      }
      size(); window.addEventListener('resize', size);
      var lastOn = 0;
      function cls() { return root.classList.contains('icy-leaving') || root.classList.contains('icy-arriving'); }
      function active() { if (cls()) { lastOn = Date.now(); return true; } return Date.now() - lastOn < 750; }
      var running = false;
      function frame() {
        if (!active()) { running = false; ctx.clearRect(0, 0, W, H); return; }
        ctx.fillStyle = 'rgba(2,6,18,0.16)'; ctx.fillRect(0, 0, W, H);
        ctx.font = '700 ' + fs + 'px "JetBrains Mono", ui-monospace, monospace';
        for (var i = 0; i < cols; i++) {
          var ch = glyphs[(Math.random() * glyphs.length) | 0], x = i * fs, y = drops[i] * fs;
          ctx.shadowBlur = 12; ctx.shadowColor = '#4DA3FF';
          ctx.fillStyle = Math.random() > .92 ? '#FFFFFF' : (Math.random() > .5 ? '#A9D4FF' : '#2F7BFF');
          ctx.fillText(ch, x, y);
          ctx.fillStyle = 'rgba(169,212,255,.55)'; ctx.fillText(glyphs[(Math.random() * glyphs.length) | 0], x, y - fs);
          drops[i] += 1.4 + (i % 3) * 0.35;
          if (y > H && Math.random() > .96) drops[i] = Math.random() * -8;
        }
        requestAnimationFrame(frame);
      }
      function kick() { if (cls()) lastOn = Date.now(); if (!running && active() && !reduce) { running = true; ctx.fillStyle = '#020612'; ctx.fillRect(0, 0, W, H); requestAnimationFrame(frame); } }
      new MutationObserver(kick).observe(root, { attributes: true, attributeFilter: ['class'] });
      kick();
    }
    matrix();
  });
})();
